<ng-select
        #select
        [items]="entries$ | async"
        bindLabel="name"
        [trackByFn]="trackByFn"
        [minTermLength]="3"
        [loading]="loading"
        placeholder="{{'label.item' | translate}}"
        typeToSearchText="Digita almeno 3 caratteri"
        [typeahead]="input$"
        [disabled]="_readonly"
        (ngModelChange)="onSelectionChange($event)"
        [clearSearchOnAdd]="clearSearchOnAddVal"
        [deselectOnClick]="deselectOnClickVal"
        [(ngModel)]="selectedEntries">

  <ng-template ng-label-tmp let-item="item">
    <div *ngIf="item" >{{ item.name }} - <small>{{ item.code }} <b> {{ item.data.supplier.name + ' ' + item.data.price + '€ ' + item.data.discount + '%'  }}</b></small></div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div *ngIf="item">
      <div>{{ item.name }}</div>
      <div>
        <small>{{ item.data.code }}<b> {{ formatSupplierData(item) }}</b></small>
      </div>
    </div>
  </ng-template>
</ng-select>